import { environment } from 'src/environments/environment';

const URL_GATEWAY_QA = 'https://wsqa.polpaicoconexion.cl/api/seguimiento-anonimo';
const URL_GATEWAY_PROD = 'https://ws.polpaicoconexion.cl/api/seguimiento-anonimo';

/** Base URL del API Gateway de seguimiento anónimo según el build (QA vs producción). */
export function getSeguimientoAnonimoGatewayBaseUrl(): string {
  return environment.production ? URL_GATEWAY_PROD : URL_GATEWAY_QA;
}

/** Concatena la base del gateway anónimo con una ruta relativa (con o sin slash inicial). */
export function seguimientoAnonimoGatewayUrl(path: string): string {
  const base = getSeguimientoAnonimoGatewayBaseUrl().replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
